import React from 'react';

import Icon from 'components/common/Icons/base/Icon/Icon';

import { CustomizedRoundIcon } from 'components/common';

export const ActionButtonError = ({ copyToClipboard }) => {
    return (
        <div onClick={copyToClipboard}>
            <CustomizedRoundIcon
                size={'30px'}
                backGroundColor={'var(--button-primary-bg_destructive)'}
                hoverColor={'none'}
            >
                <Icon name={'warning-icon'} size={'22px'} color={'var(--button-primary-fg)'} />
            </CustomizedRoundIcon>
        </div>
    );
};
